export const environment = {
   production: false,
    apiUrl: 'https://api-staging.stephubs.com/api',
    rawAPI: 'https://api-staging.stephubs.com',
    startup: 'https://startup-staging.stephubs.com',
    s3_bucket_basepath: 'https://stephubs-images.s3.amazonaws.com'
};
